import React, { ChangeEvent } from "react";

interface ProfileImageUploadProps {
  image: string;
  onImageChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const ProfileImageUpload: React.FC<ProfileImageUploadProps> = ({
  image,
  onImageChange,
}) => {
  return (
    <div className="position-relative d-inline-block">
      <img
        src={image || "/api/placeholder/96/96"}
        alt="Profile Avatar"
        style={{ objectFit: "cover" }}
        height={100}
        width={100}
        className="rounded-circle"
      />

      <label
        htmlFor="image-upload"
        className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50 rounded-circle cursor-pointer opacity-0 hover-opacity-100"
        style={{ transition: "opacity 0.3s" }}
      >
        <i className="fa-solid fa-pen text-white bg-primary p-2 rounded-circle border border-white"></i>
      </label>

      <input
        id="image-upload"
        type="file"
        className="d-none"
        accept="image/*"
        onChange={onImageChange}
      />
    </div>
  );
};

export default ProfileImageUpload;
